<template>
  <div
    class="legacy"
    style="background-color:#333"
  >   
    <embed
      src="https://legacy.transplus.ca"
      style="width:100%; height:calc(100vh - 76px) ;margin-top:76px; display: block;overflow: auto;"
    >
  </div>
</template>

<script>
  export default {}
</script>

<style>

</style>
